import { Slide } from "@jelly/lesson";

import { task as task02 } from "../../../../../task/course-03/lesson-30/task-02";

const task: Slide = {
  title: "Think what can be a good scale for these properties.",
  description: "Connect with lines.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task02.id,
        },
      },
    },
  },
};

export default task;
